export interface BrowserDetails {
    browser: string;
    platform: string;
}

/** Low-cardinality browser family plus major version for client diagnostics. */
export function browserDetails(userAgent: string, platform: string): BrowserDetails {
    const matchers: Array<[string, RegExp]> = [
        ['Edge', /Edg\/([\d.]+)/],
        ['Firefox', /Firefox\/([\d.]+)/],
        ['Chrome', /(?:Chrome|CriOS)\/([\d.]+)/],
        ['Safari', /Version\/([\d.]+).*Safari/],
    ];
    for (const [family, matcher] of matchers) {
        const match = matcher.exec(userAgent);
        if (!match) continue;
        const major = (match[1] ?? '').split('.')[0]!;
        if (/^\d{1,3}$/.test(major)) {
            return { browser: `${family}-${major}`, platform: (platform || 'unknown').slice(0, 32) };
        }
    }
    return { browser: 'unknown', platform: (platform || 'unknown').slice(0, 32) };
}
